import { OptionGroupType } from '@frontend/sports/betting-offer/feature/fixture-factories';
import { createAction, props } from '@ngrx/store';

import { PlayerStatistics } from './player-statistics.model';

export type LoadPlayerStatisticsDataPayload = { eventId: string; mainMarket: true } | { eventId: string; marketFilter: string };

export const loadPlayerStatisticsData = createAction('[Player Statistics] Load Player Statistics Data', props<LoadPlayerStatisticsDataPayload>());

export const playerStatisticsDataSuccess = createAction(
    '[Player Statistics] Player Statistics Data Success',
    props<{
        eventId: string;
        marketFilter?: string;
        data: PlayerStatistics | undefined;
        isLoading: boolean;
        isError: boolean;
    }>(),
);

export const playerStatisticsDataFailure = createAction(
    '[Player Statistics] Player Statistics Data Failure',
    props<{
        eventId: string;
        marketFilter?: string;
        data: PlayerStatistics | undefined;
        isLoading: boolean;
        isError: boolean;
    }>(),
);

export const resetPlayerStatisticsState = createAction('[Player Statistics] reset Player Statistics state');

export const setPlayerStatisticsOpenAndTrackingStatus = createAction(
    '[Player Statistics] Set Open And Tracking Status',
    props<{
        eventId: string;
        marketFilter: string;
        playerName: string;
        marketId?: string;
        optionId?: string;
        marketType?: OptionGroupType;
        isOpen?: boolean;
        tracking?: boolean;
        loadedTracking?: boolean;
    }>(),
);

export const setTeamStatisticsOpenAndTrackingStatus = createAction(
    '[Team Statistics] Set Open And Tracking Status',
    props<{
        eventId: string;
        isMainMarketOpen?: boolean;
        mainMarketTracking?: boolean | undefined;
        mainMarketLoadedTracking?: boolean;
    }>(),
);
